import * as types from '../../action/actionTypes';
import initialState from '../initialState';

export default class FacilityRequestsReducer {
    
    static FacilityRequestsMyRequestsListReducer(state = initialState.facilityRequests, action) {
          switch (action.type) {
            case types.GET_EMPLOYEE_MYREQUESTS: return {
                ...state, employee_MyRequests: action.getResponse,
             };
             default : return state; 
          }   
      }

    static FacilityRequestsAllRequestsListReducer(state = initialState.facilityRequests, action) {
        switch (action.type) {
          case types.GET_EMPLOYEE_ALLREQUESTS: return {
              ...state, employee_AllRequests: action.getResponse,
           };
           default : return state; 
        }   
    }

    static FacilityRequestsEmployeeTenantDetails(state = initialState.facilityRequests, action) {
        switch (action.type) {
           case types.GET_EMPLOYEE_TENANT_DETAILS: return {
            ...state, EmployeeTenantDetails: action.getResponse,
        };
           default : return state; 
        }   
    }
   
}  